import { IncomingMessage } from "http";

export const getCookie = (cookieName: string): string => {
  const name = `${cookieName}=`;
  const cDecoded = decodeURIComponent(document.cookie);
  return cDecoded.split("; ").reduce((acc, value) => {
    if (value.indexOf(name) === 0) {
      return value.substring(name.length);
    }
    return acc;
  }, "");
};

/**
 * Server side functionality to get a cookie from an incoming request
 * that is isomorphic and can be imported both client and server side
 * to be used in _app.
 */
export const getCookieFromRequest = (
  req: IncomingMessage,
  name: string,
): string | undefined => {
  const cookies = req.headers.cookie;
  if (cookies) {
    return cookies.split("; ").reduce<string | undefined>((r, v) => {
      const parts = v.split("=");
      return parts[0] === name ? decodeURIComponent(parts[1] || "") : r;
    }, undefined);
  }
  return undefined;
};

export const setCookie = (
  cookieName: string,
  cookieValue: string,
  days: number,
): void => {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie =
    encodeURIComponent(cookieName) +
    "=" +
    (encodeURIComponent(cookieValue) || "") +
    expires +
    "; path=/";
};
